import s from "./index49.js";
import m from "./index76.js";
import u from "./index77.js";
import { getFetch as _ } from "./index78.js";
import p from "./index60.js";
const c = {
  http: m,
  xhr: u,
  fetch: {
    get: _
  }
};
s.forEach(c, (e, o) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: o });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: o });
  }
});
const d = (e) => `- ${e}`, b = (e) => s.isFunction(e) || e === null || e === !1;
function g(e, o) {
  e = s.isArray(e) ? e : [e];
  const { length: a } = e;
  let i, t;
  const l = {};
  for (let r = 0; r < a; r++) {
    i = e[r];
    let n;
    if (t = i, !b(i) && (t = c[(n = String(i)).toLowerCase()], t === void 0))
      throw new p(`Unknown adapter '${n}'`);
    if (t && (s.isFunction(t) || (t = t.get(o))))
      break;
    l[n || "#" + r] = t;
  }
  if (!t) {
    const r = Object.entries(l).map(
      ([f, h]) => `adapter ${f} ` + (h === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let n = a ? r.length > 1 ? `since :
` + r.map(d).join(`
`) : " " + d(r[0]) : "as no adapter specified";
    throw new p(
      "There is no suitable adapter to dispatch the request " + n,
      p.ERR_NOT_SUPPORT
    );
  }
  return t;
}
const y = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: g,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: c
};
export {
  y as default
};
